import { FC } from 'react';
import { DropDownDividerContainer } from './DropDownDivider.styles';
import { DropDownDividerProps } from './DropDownDivider.types';

const DropDownDivider: FC<DropDownDividerProps> = ({ color }) => {
  return <DropDownDividerContainer color={color} />;
};

export default DropDownDivider;
